import { render, staticRenderFns } from "./contactUsNew.vue?vue&type=template&id=a2f4b206&scoped=true&"
import script from "./contactUsNew.vue?vue&type=script&lang=ts&"
export * from "./contactUsNew.vue?vue&type=script&lang=ts&"
import style0 from "./contactUsNew.vue?vue&type=style&index=0&id=a2f4b206&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f4b206",
  null
  
)

export default component.exports